import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './ModelDetail.css';

const MODELS = {
  mantaray420: {
    name: 'MANTA RAY 420',
    image: '/unimar-manta-ray-420-banner.webp',
    length: '4.2 m',
    maxHp: '50 HP',
    passengers: '5',
    features: [
      { icon: '/spec-overall-length.webp', labelKey: 'overallLength', value: '4.2 m' },
      { icon: '/spec-overall-width.webp',  labelKey: 'overallWidth',  value: '1.75 m' },
      { icon: '/spec-weight.webp',         labelKey: 'weight',         value: '220 kg' },
      { icon: '/spec-horsepower.webp',     labelKey: 'maximumHorsepower', value: '50 HP' },
      { icon: '/spec-capacity.webp',       labelKey: 'capacity',       value: '5' },
      { icon: '/spec-category.webp',       labelKey: 'category',       value: 'C' },
    ],
    featuresShowcase: '/unimar-manta-ray-420-features.webp',
    gallery: [
      '/gallery/mantaray420/m1.webp', '/gallery/mantaray420/m2.webp', '/gallery/mantaray420/m3.webp',
      '/gallery/mantaray420/m4.webp', '/gallery/mantaray420/m5.webp', '/gallery/mantaray420/m6.webp',
      '/gallery/mantaray420/m7.webp', '/gallery/mantaray420/m8.webp', '/gallery/mantaray420/m9.webp',
      '/gallery/mantaray420/m10.webp', '/gallery/mantaray420/m11.webp', '/gallery/mantaray420/m12.webp',
      '/gallery/mantaray420/m13.webp', '/gallery/mantaray420/m14.webp', '/gallery/mantaray420/m15.webp',
      '/gallery/mantaray420/m16.webp', '/gallery/mantaray420/m17.webp', '/gallery/mantaray420/m18.webp',
      '/gallery/mantaray420/m19.webp', '/gallery/mantaray420/m20.webp',
    ],
    galleryBg: { 0: '#79B3B7', 1: '#FFEBD0', 2: '#79B3B7', 3: '#79B3B7', 4: '#FFEBD0' },
    techSpecs: [
      { labelKey: 'length',      value: '4.20 m' },
      { labelKey: 'width',       value: '1.75 m' },
      { labelKey: 'height',      value: '0.55 m' },
      { labelKey: 'draft',       value: '0.23 / 0.35 m' },
      { labelKey: 'weightBasic', value: '220 kg' },
      { labelKey: 'weightSport', value: '260 kg' },
      { labelKey: 'maxPower',    value: '50 HP' },
      { labelKey: 'category',    value: 'C' },
    ],
    additionalEquipmentPrices: [
      '520 €', '400 €', '600 €', '260 €', '250 €', '150 €',
      '80 €', '60 €', '100 €', '50 €', '120 €', '480 €',
      '180 €', '680 €', '1,250 €', '140 €', '200 €',
    ],
  },
  stia580: {
    name: 'STIA 580',
    image: '/unimar-stia-580-hero.webp',
    length: '5.76 m',
    maxHp: '140 HP',
    passengers: '6',
    features: [
      { icon: '/spec-overall-length.webp', labelKey: 'overallLength',      value: '5.76 m' },
      { icon: '/spec-overall-width.webp',  labelKey: 'overallWidth',       value: '2.2 m' },
      { icon: '/spec-weight.webp',         labelKey: 'weight',              value: '600 kg' },
      { icon: '/spec-horsepower.webp',     labelKey: 'maximumHorsepower',  value: '140 HP' },
      { icon: '/spec-capacity.webp',       labelKey: 'capacity',            value: '6' },
      { icon: '/spec-category.webp',       labelKey: 'category',            value: 'C' },
    ],
    featuresShowcase: '/unimar-stia-580-features.webp',
    gallery: [
      '/gallery/stia580/p1.webp', '/gallery/stia580/p2.webp', '/gallery/stia580/p3.webp',
      '/gallery/stia580/p4.webp', '/gallery/stia580/p5.webp', '/gallery/stia580/p6.webp',
      '/gallery/stia580/p7.webp', '/gallery/stia580/p8.webp', '/gallery/stia580/p9.webp',
      '/gallery/stia580/p11.webp', '/gallery/stia580/p12.webp', '/gallery/stia580/p13.webp',
      '/gallery/stia580/p14.webp', '/gallery/stia580/p15.webp', '/gallery/stia580/p16.webp',
      '/gallery/stia580/p18.webp', '/gallery/stia580/p20.webp',
      '/gallery/stia580/p22.webp', '/gallery/stia580/p23.webp', '/gallery/stia580/p24.webp',
    ],
    techSpecs: [
      { labelKey: 'length',          value: '5.76 m' },
      { labelKey: 'width',           value: '2.20 m' },
      { labelKey: 'weightBasic',     value: '600 kg' },
      { labelKey: 'draft',           value: '25 cm' },
      { labelKey: 'recommendedPower',value: '80 HP' },
      { labelKey: 'maximumPower',    value: '140 HP' },
      { labelKey: 'capacityPersons', value: '6' },
      { labelKey: 'category',        value: 'C' },
    ],
    additionalEquipmentPrices: [
      '570 €', '290 €', '430 €', '780 €', '780 €', '950 €', '970 €', '700 €', '1,500 €',
    ],
  },
  real500: {
    name: 'REAL 500',
    image: '/unimar-real-500-banner.webp',
    length: '5.0 m',
    maxHp: '100 HP',
    passengers: '6',
    features: [
      { icon: '/spec-overall-length.webp', labelKey: 'overallLength',     value: '5.0 m' },
      { icon: '/spec-overall-width.webp',  labelKey: 'overallWidth',      value: '1.88 m' },
      { icon: '/spec-weight.webp',         labelKey: 'weight',             value: '320 kg' },
      { icon: '/spec-horsepower.webp',     labelKey: 'maximumHorsepower', value: '100 HP' },
      { icon: '/spec-capacity.webp',       labelKey: 'capacity',           value: '6' },
      { icon: '/spec-category.webp',       labelKey: 'category',           value: 'C' },
    ],
    featuresShowcase: '/unimar-real-500-features.webp',
    gallery: [
      '/gallery/real500/r1.webp', '/gallery/real500/r2.webp', '/gallery/real500/r3.webp',
      '/gallery/real500/r4.webp', '/gallery/real500/r5.webp', '/gallery/real500/r6.webp',
      '/gallery/real500/r7.webp', '/gallery/real500/r8.webp', '/gallery/real500/r9.webp',
      '/gallery/real500/r10.webp', '/gallery/real500/r11.webp', '/gallery/real500/r12.webp',
      '/gallery/real500/r13.webp', '/gallery/real500/r14.webp', '/gallery/real500/r15.webp',
    ],
    techSpecs: [
      { labelKey: 'length',      value: '5.00 m' },
      { labelKey: 'width',       value: '1.88 m' },
      { labelKey: 'height',      value: '0.55 m' },
      { labelKey: 'draft',       value: '0.23 / 0.35 m' },
      { labelKey: 'weightBasic', value: '320 kg' },
      { labelKey: 'weightSport', value: '360 kg' },
      { labelKey: 'maxPower',    value: '100 HP' },
      { labelKey: 'category',    value: 'C' },
    ],
    additionalEquipmentPrices: [
      '650 €', '450 €', '690 €', '290 €', '250 €', '150 €', '200 €',
      '80 €', '60 €', '100 €', '50 €', '120 €',
      '530 €', '180 €', '680 €', '1,250 €', '140 €',
    ],
  },
};

function ModelDetail() {
  const { t } = useTranslation();
  const [galleryIndex, setGalleryIndex] = React.useState(0);
  const [lightboxIndex, setLightboxIndex] = React.useState(null);
  const lbTouchStartX = React.useRef(null);
  const [activeTab, setActiveTab] = React.useState('overview');
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 767);
  const { key } = useParams();
  const navigate = useNavigate();
  const model = MODELS[key];

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slidesPerView = isMobile ? 1 : 3;
  const slidePercent = 100 / slidesPerView;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveTab(sectionId);
    }
  };

  React.useEffect(() => {
    const tabs = document.querySelectorAll('.model-detail__equipment-tab');
    const contents = document.querySelectorAll('.model-detail__equipment-content');
    tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('model-detail__equipment-tab--active'));
        contents.forEach(c => c.classList.remove('model-detail__equipment-content--active'));
        tab.classList.add('model-detail__equipment-tab--active');
        if (contents[idx]) contents[idx].classList.add('model-detail__equipment-content--active');
      });
    });
  }, []);

  if (!model) {
    return (
      <div className="model-detail">
        <Header />
        <div className="model-detail__not-found">
          <h1>Model not found</h1>
          <button onClick={() => navigate('/models')} className="model-detail__back-btn">
            {t('modelDetail.ui.allModels')}
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const desc = t(`modelDetail.${key}.desc`);
  const characteristics = t(`modelDetail.${key}.characteristics`, { returnObjects: true });
  const standardEquipment = t(`modelDetail.${key}.standardEquipment`, { returnObjects: true });
  const standardEquipmentPrice = t(`modelDetail.${key}.standardEquipmentPrice`, { defaultValue: '' });
  const basicEquipment = t(`modelDetail.${key}.basicEquipment`, { returnObjects: true });
  const basicEquipmentPrice = t(`modelDetail.${key}.basicEquipmentPrice`, { defaultValue: '' });
  const sportEquipment = t(`modelDetail.${key}.sportEquipment`, { returnObjects: true });
  const sportEquipmentPrice = t(`modelDetail.${key}.sportEquipmentPrice`, { defaultValue: '' });
  const additionalEquipmentNames = t(`modelDetail.${key}.additionalEquipment`, { returnObjects: true });

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: model.name,
    description: desc,
    brand: { '@type': 'Brand', name: 'Unimar' },
    image: `https://unimar.mk${model.image}`,
    url: `https://unimar.mk/models/${key}`,
    offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', seller: { '@type': 'Organization', name: 'Unimar' } },
  };

  return (
    <div className="model-detail">
      <SEO
        title={model.name}
        description={desc}
        image={model.image}
        url={`/models/${key}`}
        type="product"
        structuredData={structuredData}
      />
      <Header />

      {/* Hero Banner */}
      <section className="model-detail__hero-banner">
        <img src={model.image} alt={model.name} className="model-detail__hero-banner-img" />
        <div className="model-detail__hero-banner-overlay" />
        <button className="model-detail__breadcrumb" onClick={() => navigate('/models')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {t('modelDetail.ui.allModels')}
        </button>
      </section>

      {/* Model Nav Bar */}
      <div className="model-detail__navbar">
        <div className="model-detail__navbar-inner">
          <div className="model-detail__navbar-tabs">
            <button
              className={`model-detail__navbar-tab ${activeTab === 'overview' ? 'model-detail__navbar-tab--active' : ''}`}
              onClick={() => scrollToSection('overview')}
            >
              {t('modelDetail.ui.overview')}
            </button>
            {model.gallery && (
              <button
                className={`model-detail__navbar-tab ${activeTab === 'photos' ? 'model-detail__navbar-tab--active' : ''}`}
                onClick={() => scrollToSection('photos')}
              >
                {t('modelDetail.ui.photos')}
              </button>
            )}
            {model.features && (
              <button
                className={`model-detail__navbar-tab ${activeTab === 'specs' ? 'model-detail__navbar-tab--active' : ''}`}
                onClick={() => scrollToSection('specs')}
              >
                {t('modelDetail.ui.features')}
              </button>
            )}
            <button
              className={`model-detail__navbar-tab ${activeTab === 'options' ? 'model-detail__navbar-tab--active' : ''}`}
              onClick={() => scrollToSection('options')}
            >
              {t('modelDetail.ui.equipment')}
            </button>
          </div>
          {key === 'stia580' && (
            <a href="/configurator" className="model-detail__navbar-build" data-ga-click="cta-build-and-price">
              {t('modelDetail.ui.buildAndPrice')}
            </a>
          )}
        </div>
      </div>

      {/* Info */}
      <section className="model-detail__hero" id="overview">
        <div className="model-detail__hero-inner">
          <div className="model-detail__hero-text">
            <h1 className="model-detail__name">{model.name}</h1>
            {desc.split('\n\n').map((para, i) => (
              <p key={i} className="model-detail__desc">{para}</p>
            ))}
          </div>
          {Array.isArray(characteristics) && characteristics.length > 0 && (
            <div className="model-detail__hero-characteristics">
              <span className="model-detail__chars-label">{t('modelDetail.ui.characteristics')}</span>
              <div className="model-detail__chars-tags">
                {characteristics.map((c) => (
                  <span key={c} className="model-detail__chars-tag">
                    <span className="model-detail__chars-dot" />
                    {c}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Features Section */}
      {model.features && (
        <section className="model-detail__stia-features" id="specs">
          <div className="model-detail__stia-features-inner">
            <div className="model-detail__stia-features-left">
              <h2 className="model-detail__stia-features-title">{t('modelDetail.ui.featuresTitle')}</h2>
              <div className="model-detail__stia-features-list">
                {model.features.map((feature, idx) => (
                  <div key={idx} className="model-detail__stia-feature-item">
                    <div className="model-detail__stia-feature-icon">
                      <img src={feature.icon} alt={t(`modelDetail.featureLabels.${feature.labelKey}`)} />
                    </div>
                    <div className="model-detail__stia-feature-text">
                      <h3>{feature.value}</h3>
                      <p>{t(`modelDetail.featureLabels.${feature.labelKey}`)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="model-detail__stia-features-right">
              <img src={model.featuresShowcase} alt="Features Showcase" className="model-detail__stia-features-showcase" />
            </div>
          </div>
        </section>
      )}

      {/* Gallery Carousel */}
      {model.gallery && (
        <section className="model-detail__gallery" id="photos">
          <div className="model-detail__gallery-inner">
            <h2 className="model-detail__gallery-title">{t('modelDetail.ui.photos')}</h2>
          </div>
          <div className="model-detail__carousel">
            <div className="model-detail__carousel-container">
              <div
                className="model-detail__carousel-track"
                style={{ transform: `translateX(-${galleryIndex * slidePercent}%)` }}
              >
                {model.gallery.map((src, idx) => (
                  <div
                    key={idx}
                    className="model-detail__carousel-slide"
                    style={model.galleryBg?.[idx] ? { background: model.galleryBg[idx] } : {}}
                  >
                    <img
                      src={src}
                      alt={`${model.name} ${idx + 1}`}
                      onClick={() => setLightboxIndex(idx)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                ))}
              </div>
            </div>

            <button
              className="model-detail__carousel-btn model-detail__carousel-btn--prev"
              onClick={() => setGalleryIndex((i) => Math.max(0, i - 1))}
              disabled={galleryIndex === 0}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <button
              className="model-detail__carousel-btn model-detail__carousel-btn--next"
              onClick={() => setGalleryIndex((i) => Math.min(model.gallery.length - slidesPerView, i + 1))}
              disabled={galleryIndex >= model.gallery.length - slidesPerView}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="model-detail__carousel-dots">
              {Array.from({ length: model.gallery.length - slidesPerView + 1 }).map((_, idx) => (
                <button
                  key={idx}
                  className={`model-detail__carousel-dot ${idx === galleryIndex ? 'model-detail__carousel-dot--active' : ''}`}
                  onClick={() => setGalleryIndex(idx)}
                />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div
          className="model-detail__lightbox"
          onClick={() => setLightboxIndex(null)}
          onTouchStart={(e) => { lbTouchStartX.current = e.touches[0].clientX; }}
          onTouchEnd={(e) => {
            if (lbTouchStartX.current === null) return;
            const diff = lbTouchStartX.current - e.changedTouches[0].clientX;
            lbTouchStartX.current = null;
            if (Math.abs(diff) > 50) {
              if (diff > 0) setLightboxIndex((i) => Math.min(model.gallery.length - 1, i + 1));
              else setLightboxIndex((i) => Math.max(0, i - 1));
            }
          }}
        >
          <div className="model-detail__lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="model-detail__lightbox-close" onClick={() => setLightboxIndex(null)}>✕</button>
            <button
              className="model-detail__lightbox-arrow model-detail__lightbox-arrow--prev"
              onClick={() => setLightboxIndex((i) => Math.max(0, i - 1))}
              disabled={lightboxIndex === 0}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
            <img src={model.gallery[lightboxIndex]} alt="Fullscreen" className="model-detail__lightbox-image" />
            <button
              className="model-detail__lightbox-arrow model-detail__lightbox-arrow--next"
              onClick={() => setLightboxIndex((i) => Math.min(model.gallery.length - 1, i + 1))}
              disabled={lightboxIndex === model.gallery.length - 1}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
            <div className="model-detail__lightbox-dots">
              {model.gallery.map((_, i) => (
                <span key={i} className={`model-detail__lightbox-dot${i === lightboxIndex ? ' model-detail__lightbox-dot--active' : ''}`} />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Standard & Additional Equipment */}
      <section className="model-detail__equip-section" id="options">
        <div className="model-detail__equip-inner">

          {/* BASIC Equipment (if separate sections exist) */}
          {Array.isArray(basicEquipment) && basicEquipment.length > 0 && (
            <div className="model-detail__equip-block">
              <div className="model-detail__equip-header">
                <span className="model-detail__equip-header-title">{t('modelDetail.ui.standardEquipment')} – BASIC</span>
                <span className="model-detail__equip-header-model">{basicEquipmentPrice}</span>
              </div>
              <ul className="model-detail__equip-grid">
                {basicEquipment.map((item, i) => (
                  <li key={i} className="model-detail__equip-item">
                    <span className="model-detail__equip-check">✓</span>
                    <span className="model-detail__equip-name">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* SPORT Equipment (if separate sections exist) */}
          {Array.isArray(sportEquipment) && sportEquipment.length > 0 && (
            <div className="model-detail__equip-block">
              <div className="model-detail__equip-header">
                <span className="model-detail__equip-header-title">{t('modelDetail.ui.standardEquipment')} – SPORT</span>
                <span className="model-detail__equip-header-model">{sportEquipmentPrice}</span>
              </div>
              <ul className="model-detail__equip-grid">
                {sportEquipment.map((item, i) => (
                  <li key={i} className="model-detail__equip-item">
                    <span className="model-detail__equip-check">✓</span>
                    <span className="model-detail__equip-name">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Standard Equipment (fallback for non-split models) */}
          {!Array.isArray(sportEquipment) && (
            <div className="model-detail__equip-block">
              <div className="model-detail__equip-header">
                <span className="model-detail__equip-header-title">{t('modelDetail.ui.standardEquipment')}</span>
                <span className="model-detail__equip-header-model">{standardEquipmentPrice}</span>
              </div>
              <ul className="model-detail__equip-grid">
                {Array.isArray(standardEquipment) && standardEquipment.map((item, i) => (
                  <li key={i} className="model-detail__equip-item">
                    <span className="model-detail__equip-check">✓</span>
                    <span className="model-detail__equip-name">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Additional Equipment */}
          <div className="model-detail__equip-block">
            <div className="model-detail__equip-header">
              <span className="model-detail__equip-header-title">{t('modelDetail.ui.additionalEquipment')}</span>
              <span className="model-detail__equip-header-model">{model.name}</span>
            </div>
            <ul className="model-detail__equip-list">
              {Array.isArray(additionalEquipmentNames) && additionalEquipmentNames.map((name, i) => (
                <li key={i} className="model-detail__equip-item">
                  <span className="model-detail__equip-check">✓</span>
                  <span className="model-detail__equip-name">{name}</span>
                  {model.additionalEquipmentPrices?.[i] && (
                    <span className="model-detail__equip-price">{model.additionalEquipmentPrices[i]}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="model-detail__equip-cta">
            <a href="/book-showcase" className="model-detail__equip-btn" data-ga-click={`cta-book-showcase-${key}`}>{t('modelDetail.ui.bookShowcase')}</a>
            {key === 'stia580' && (
              <a href="/configurator" className="model-detail__equip-btn" data-ga-click="cta-configure-stia580">{t('modelDetail.ui.build')}</a>
            )}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ModelDetail;
